export default __webpack_public_path__ + "static/media/Subtraction_07.5a7abb01.png";